<script setup lang="ts">
  import { ref, useTemplateRef } from 'vue';

  import type { DisputeReason, Partner } from '@stuut/api/models';
  import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@ui/components/dialog';
  import { ScrollArea } from '@ui/components/scroll-area';

  import DisputeReasonForm from '@/components/disputes/DisputeReasonForm.vue';

  interface Props {
    customer?: Partner;
    disputeReason?: DisputeReason;
  }

  defineProps<Props>();

  const emits = defineEmits<{
    (e: 'close'): void;
    (e: 'complete', DisputeReason): void;
  }>();

  const ReasonSelectRef = useTemplateRef('reasonSelectRef');

  const showConfigReasonCode = ref(false);

  const openDiputeReasonDialog = () => {
    showConfigReasonCode.value = true;
  };

  const closeDiputeReasonDialog = () => {
    showConfigReasonCode.value = false;
  };

  defineExpose({
    hide: closeDiputeReasonDialog,
    ReasonSelectRef,
    show: openDiputeReasonDialog,
  });
</script>

<template>
  <Dialog ref="reasonSelectRef" v-model:open="showConfigReasonCode">
    <DialogContent class="lg:max-w-162 max-h-[min(800px,80vh)] overflow-hidden p-0">
      <ScrollArea class="max-h-[min(800px,80vh)] p-6 [&>div]:outline-none">
        <DialogHeader class="mb-4">
          <DialogTitle class="flex items-center justify-between">
            <template v-if="disputeReason?.id">
              <span>Edit "{{ disputeReason?.name || disputeReason?.code }}"</span>
            </template>

            <template v-else> Create a dispute reason </template>
          </DialogTitle>
        </DialogHeader>

        <DisputeReasonForm
          :dispute-reason="disputeReason"
          @complete="(disputeReason) => emits('complete', disputeReason)"
          @close="closeDiputeReasonDialog"
        />
      </ScrollArea>
    </DialogContent>
  </Dialog>
</template>

<style scoped></style>
